/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Form_LoadingInputs */



/**
* | output |
* | --- |
* | "Loading this practice conversation…" |
*
* @param {Practice_Form_LoadingInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_form_loading = /** @type {((inputs?: Practice_Form_LoadingInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Form_LoadingInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Dit oefengesprek wordt geladen…")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Chargement de cette conversation d’entraînement…")
	return /** @type {LocalizedString} */ ("Loading this practice conversation…")
});